import type { ActionInput, MatchState } from "../game/simulation";

export type SnapshotListener = (state: MatchState) => void;
export type InputListener = (input: ActionInput) => void;

export class SceneBridge {
  private state: MatchState | null = null;
  private readonly snapshotListeners = new Set<SnapshotListener>();
  private readonly inputListeners = new Set<InputListener>();

  publishSnapshot(state: MatchState): void {
    this.state = state;
    this.snapshotListeners.forEach((listener) => listener(state));
  }

  latestSnapshot(): MatchState | null {
    return this.state;
  }

  emitInput(input: ActionInput): void {
    this.inputListeners.forEach((listener) => listener(input));
  }

  onSnapshot(listener: SnapshotListener): () => void {
    this.snapshotListeners.add(listener);
    return () => this.snapshotListeners.delete(listener);
  }

  onInput(listener: InputListener): () => void {
    this.inputListeners.add(listener);
    return () => this.inputListeners.delete(listener);
  }
}

